(function () {
    'use strict';

    angular
      .module('sprechstunde')
      .config(config);

    config.$inject = ['$urlRouterProvider', '$stateProvider'];

    // when using states you only need the default route
    function config($urlRouterProvider, $stateProvider) {
      $urlRouterProvider.when('/', '');
      $urlRouterProvider.otherwise('/home');

      // startpage
      $stateProvider
        .state('home', {
          url: '/home',
          views: {
            main: {templateUrl: 'home/home.tpl.html'}
          }
        });

    }
  }()
);